// extracted by mini-css-extract-plugin
export default {"page":"Yq-z","landingBackground":"Zq-z","nonLandingBackground":"_q-z"};